import "./styles.less";

import * as React from "react";

import { Button, Grid, Space } from "antd";
import { MouseEvent, useContext, useEffect, useRef, useState } from "react";
import { OwnerPhoneInterface, usePhoneButton } from "./hook";

import { ModalPhone } from "../../../ModalPhone/web";
import { PhoneOutlined, PhoneFilled } from "@ant-design/icons";
import { useFacebookPixel } from "../../../../../GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { useTheme } from "../../../../../Styles/ThemeHook";
import Text from "antd/lib/typography/Text";
import { ConfigStateContext } from "../../../../../Contexts/Configurations/context";
import { ModalState } from "../../TextForm/type";
import { LoadingIcon } from "shared-components/Components/CustomIcons/LoadingIcon/LoadingIcon";
const { useBreakpoint } = Grid;

export const PhoneButton = ({
	id,
	type = "callButton",
	mode,
	disabled = false,
	seller = false,
	queryRouter,
	icon = false,
	btnType = "default",
	onPhoneClick,
	forceState = ModalState.DEFAULT,
}: OwnerPhoneInterface) => {
	const FP = useFacebookPixel();
	const { theme } = useTheme();
	const screen = useBreakpoint();
	const router = useRouter();
	const callPhone = useRef(null);
	const { country_code } = useContext(ConfigStateContext);

	const {
		viewPhone,
		masked_phone,
		phone,
		owner_name,
		loading,
		operation_type_name,
	} = usePhoneButton({
		property_id: id,
		seller,
	});

	const [modal, setModal] = useState(false);
	useEffect(() => {
		if (forceState == ModalState.CLOSE) {
			setModal(false)
		}
		else if (forceState == ModalState.OPEN) {
			setModal(true)
		}
	}, [forceState])

	// Simula el click de ver "Telefono"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "call") {
				if (callPhone.current) callPhone.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	const sendEvent = () => {
		const action = operation_type_name ? operation_type_name : router.asPath;
		const categoryName: string = "Consultas Tel";

		FP.StandardEvent(categoryName);
	};

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (!phone) {
			viewPhone().then(data => {
				if (data) {
					sendEvent();
					setModal(true);
				}
			});
		} else {
			sendEvent();
			setModal(true);
		}
	};

	const viewPhoneBtn = (
		<>
			<Space size={4} className="view-phone-btn">
				{icon && <PhoneFilled />}
				<Text className="masked">{masked_phone}</Text>
				{masked_phone && (
					<Button
						ref={callPhone}
						loading={loading}
						onClick={handleClick}
						className="secondary"
						type={btnType}
						disabled={disabled}>
						{"Ver teléfono"}
					</Button>
				)}
			</Space>
		</>
	);

	const callBtn = (
		<button
			ref={callPhone}
			className="phone-button information-request"
			onClick={handleClick}
			disabled={disabled}
		>
			{loading ? (
				<LoadingIcon classes="loading-icon" width={16} />
			) : (
				<span className="btn-icon">
					{
						country_code === "ce3" ? (
							<PhoneFilled style={{ color: theme.colors.linkColor }} />
						) : (
							<PhoneOutlined />
						)
					}
				</span>
			)}
		</button>
	);

	if (!masked_phone) {
		return null;
	}

	return (
		<>
			{type == "callButton" ? callBtn : viewPhoneBtn}
			<ModalPhone
				visible={modal}
				loading={loading}
				onCancel={() => setModal(false)}
				property_id={id}
				owner_name={owner_name}
				phone={phone}
				mode={mode}
				onClick={onPhoneClick}
			/>
		</>
	);
};










